import { render, staticRenderFns } from "./supervisorDetails-hyj.vue?vue&type=template&id=8dab0df0"
import script from "./supervisorDetails-hyj.vue?vue&type=script&lang=js"
export * from "./supervisorDetails-hyj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports